<div id="barquette-container">
  <span>Réduction appliquée à partir de</span>
  <yo-number-box
    min="0"
    [disabled]="!parametreCalculConditionnement?.siteLocal"
    [value]="parametreCalculConditionnement?.minimumBarquetteRequired"
    (onValueChanged)="onUpdateMinimumBarquetteRequired($event)">
  </yo-number-box>
  <span>contenants</span>
</div>

<div class="tranche-container">

  <div class="tranche-line">
    <p class="description">
      Pour un volume de 0 à X portions à conditionner,<br/>
      l’outil peut réviser le nombre de contenants servis (arrondi au supérieur ou au reste),<br/>
      sous réserve que l’écart généré ne dépasse pas Y couverts servis supplémentaires.
    </p>
  </div>

  <div class="tranche-line tranche-header">
    <span class="header">A partir de X portion(s)</span>
    <span class="header">Nombre de portions supplémentaires autorisées</span>
    <span class="header"></span>
  </div>

  <div class="tranche-line">
    <div class="tranche-cell">
      <yo-number-box
        min="0"
        [value]="newTranche?.start"
        [disabled]="!parametreCalculConditionnement?.siteLocal"
        (onValueChanged)="updateStartValue($event)">
      </yo-number-box>
    </div>
    <div class="tranche-cell">
      <yo-number-box
        min="0"
        [value]="newTranche?.quantityAllowed"
        [disabled]="!parametreCalculConditionnement?.siteLocal"
        (onValueChanged)="updateQuantityAllowedValue($event)">
      </yo-number-box>
    </div>
    <div class="tranche-cell">
      <yo-button
        [theme]="ButtonThemeEnum.SAVE_INNER"
        [disabled]="!parametreCalculConditionnement?.siteLocal"
        iconClass="fas fa-plus"
        tooltip="Ajouter la tranche"
        (onClick)="addTranche()">
      </yo-button>
    </div>
  </div>

  <div class="tranche-list">
    <div *ngFor="let tranche of parametreCalculConditionnement?.trancheReductionList" class="tranche-line">

      <div class="tranche-cell">
        <yo-number-box
          min="0"
          [value]="tranche?.start"
          [disabled]="!parametreCalculConditionnement?.siteLocal"
          readonly="true"
          (onValueChanged)="updateTrancheStartValue($event, tranche)" disabled>
        </yo-number-box>
      </div>
      <div class="tranche-cell">
        <yo-number-box
          min="0"
          [disabled]="!parametreCalculConditionnement?.siteLocal"
          [value]="tranche?.quantityAllowed"
          (onValueChanged)="updateTrancheQuantityAllowedValue($event, tranche)">
        </yo-number-box>
      </div>
      <div class="tranche-cell">
        <yo-button
          [class.hidden]="tranche?.start == 0"
          [theme]="ButtonThemeEnum.CANCEL_INNER"
          [disabled]="!parametreCalculConditionnement?.siteLocal"
          iconClass="fas fa-trash"
          tooltip="Supprimer la tranche"
          (onClick)="deleteTranche(tranche)">
        </yo-button>
      </div>

    </div>
  </div>

</div>
